<template>
    <router-link :to="{name: 'Dashboard'}" class="return-dashboard left-align">
        <b-button>
            <b-icon-arrow-left></b-icon-arrow-left> Retourner au tableau de bord
        </b-button>
    </router-link>
</template>

<script>
export default {
    name:"DashboardLinkButton",
}
</script>

<style scoped>
.return-dashboard {
    text-decoration: none;
    display: flex;
    margin: 0.5em auto;
    width: fit-content;
}
</style>